import http from "@/common/http.service";

const GET_CLIENTPALN = "account/plan";
const SAVE_LAST_SELECTED_PLAN = "client-plan/select";
export const getPlanDetails = (params) => {
  return http.post(GET_CLIENTPALN, params);
};

export const setLastSelectedPlan = (params) => {
  return http.post(SAVE_LAST_SELECTED_PLAN, params);
};
